import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/functions")({
  component: FunctionsLayout,
});

function FunctionsLayout() {
  return <Outlet />;
}
